const LOCAL_STORAGE = globalThis.localStorage || null;
const methods = () => {
  return {
    get: (key: string) => LOCAL_STORAGE?.getItem(key),
    set: (key: string, value: string) => LOCAL_STORAGE?.setItem(key, value),
    remove: (key: string) => LOCAL_STORAGE?.removeItem(key),
  };
};

/**
 * Browser storage utility.
 */
export const BrowserStorage = methods();
